import type {ThesaurusValue} from 'schemaDefinition/types';
import type {
  RelatedThesaurusNode,
  SearchMatch,
  ThesaurusNode,
} from 'services/thesaurus/types';
import {compareTexts} from './compareTexts';

export const getSearchMatches = (
  query: string,
  thesaurusValue: ThesaurusValue | undefined,
  getDisplayCode: (node: ThesaurusNode) => string | undefined,
  node: ThesaurusNode,
  ancestors: ThesaurusNode[],
  includeDeactivatedValues: boolean,
): SearchMatch[] => {
  if (
    !includeDeactivatedValues &&
    node.deactivated &&
    !thesaurusValue?.includes(node.code)
  ) {
    return [];
  }

  const matches: SearchMatch[] = [];
  const code = getDisplayCode(node);
  const hasTitleMatch =
    compareTexts(node.label, query) || compareTexts(code, query);

  const hasNoteMatch = !!(node.note && compareTexts(node.note, query));

  const hasSynonymMatch = !!(
    node.alternativeLabels &&
    node.alternativeLabels.some(s => compareTexts(s, query))
  );

  const hasRelatedMatch = hasRelatedSearchMatches(
    query,
    getDisplayCode,
    node.related,
  );

  if (hasTitleMatch || hasNoteMatch || hasSynonymMatch || hasRelatedMatch) {
    matches.push({
      node,
      ancestors: ancestors,
      hasTitleMatch,
      hasNoteMatch,
      hasSynonymMatch,
    });
  }

  return matches;
};

const hasRelatedSearchMatches = (
  query: string,
  getDisplayCode: (node: ThesaurusNode) => string | undefined,
  nodes: RelatedThesaurusNode[] = [],
): boolean => {
  return nodes.some(n => {
    const code = getDisplayCode(n);
    return (
      compareTexts(n.label, query) ||
      compareTexts(code, query) ||
      (n.note && compareTexts(n.note, query))
    );
  });
};
